import downloadFile from '@/common/downloadFile'
import MOCService from '@/services/moc.service'
import axios from 'axios'

let cancelTokens = []

export default {
  namespaced: true,
  state: {
    processing: [],
    archives: [],
    errors: []
  },
  getters: {},
  mutations: {
    ADD_ARCHIVE(state, data) {
      if (state.archives.findIndex(a => a.mocId === data.mocId) > -1) return
      state.archives.push(data)
    },
    REMOVE_MOC_FROM_IN_PROGRESS_LIST(state, mocId) {
      removeFromArray(state.processing, mocId)
    },
    REMOVE_MOC_FROM_LIST(state, mocId) {
      const index = state.archives.findIndex(a => a.mocId === mocId)
      if (index > -1) {
        state.archives.splice(index, 1)
      }
    },
    SET_PROCESSING_MOC_ARCHIVE(state, mocId) {
      addToArray(state.processing, mocId)
    },
    SET_ERRORS_MOC_ARCHIVE(state, mocId) {
      addToArray(state.errors, mocId)
    },
    REMOVE_MOC_FROM_ERRORS(state, mocId) {
      removeFromArray(state.errors, mocId)
    }
  },
  actions: {
    async downloadMocArchive({ commit, state }, mocId) {
      if (state.processing.indexOf(mocId) > -1) return
      commit('ADD_ARCHIVE', { mocId })
      commit('SET_PROCESSING_MOC_ARCHIVE', mocId)
      return processArchive(commit, mocId, MOCService.getArchive, true)
    },
    async downloadEmoc1Archive({ commit, state }, mocId) {
      if (state.processing.indexOf(mocId) > -1) return
      commit('ADD_ARCHIVE', { mocId })
      commit('SET_PROCESSING_MOC_ARCHIVE', mocId)
      return processArchive(commit, mocId, MOCService.getEmoc1Archive)
    },
    async retry({ commit, state }, mocId) {
      if (state.processing.indexOf(mocId) > -1) return
      commit('REMOVE_MOC_FROM_ERRORS', mocId)
      commit('SET_PROCESSING_MOC_ARCHIVE', mocId)
      return processArchive(commit, mocId)
    },
    remove({ commit }, mocId) {
      const cancelTokenIndex = cancelTokens.findIndex(c => c.mocId === mocId)
      if (cancelTokenIndex > -1) {
        cancelTokens[cancelTokenIndex].source.cancel('CANCELLED_BY_USER')
      }
      commit('REMOVE_MOC_FROM_IN_PROGRESS_LIST', mocId)
      commit('REMOVE_MOC_FROM_LIST', mocId)
    }
  }
}

const processArchive = (commit, mocId, downloadArchive, skipDownload = false) => {
  const source = axios.CancelToken.source()
  cancelTokens.push({ mocId, source })
  return downloadArchive(mocId, source.token)
    .then(result => {
      if (!skipDownload) {
        downloadFile(result, 'zip', `${mocId}.zip`)
      }
      setTimeout(() => {
        commit('REMOVE_MOC_FROM_LIST', mocId)
      }, 60000)
      return result
    })
    .catch(e => {
      if (e.message === 'CANCELLED_BY_USER') return
      commit('SET_ERRORS_MOC_ARCHIVE', mocId)
      setTimeout(() => {
        commit('REMOVE_MOC_FROM_LIST', mocId)
        commit('REMOVE_MOC_FROM_ERRORS', mocId)
      }, 60000)
    })
    .finally(() => {
      commit('REMOVE_MOC_FROM_IN_PROGRESS_LIST', mocId)
      setTimeout(() => {
        commit('REMOVE_MOC_FROM_ERRORS', mocId)
      }, 60000)
      const cancelTokenIndex = cancelTokens.findIndex(c => c.mocId === mocId)
      if (cancelTokenIndex > -1) {
        cancelTokens.splice(cancelTokenIndex, 1)
      }
    })
}

const removeFromArray = (array, value) => {
  const index = array.indexOf(value)
  if (index > -1) {
    array.splice(index, 1)
  }
}

const addToArray = (array, value) => {
  if (array.indexOf(value) > -1) return
  array.push(value)
}
